import script from "./GlobalSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&setup=true&lang=js"

import "./GlobalSearch.vue?vue&type=style&index=0&id=e01f73b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e01f73b2"]])

export default __exports__